import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { loadConsent } from '@/lib/analytics';
import { loadMetaPixel, disableMetaPixel, trackPixelPageView } from '@/lib/metaPixel';

export const MetaPixelTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const consent = loadConsent();
    if (consent?.marketing) loadMetaPixel();
    else disableMetaPixel();

    const handler = (e: Event) => {
      const detail = (e as CustomEvent).detail;
      if (detail?.marketing === true) {
        loadMetaPixel();
        trackPixelPageView();
      } else {
        disableMetaPixel();
      }
    };
    window.addEventListener('aimup-cookie-consent-changed', handler);
    return () => window.removeEventListener('aimup-cookie-consent-changed', handler);
  }, []);

  useEffect(() => {
    trackPixelPageView();
  }, [location.pathname, location.search]);

  return null;
};

export default MetaPixelTracker;
